<template>
  <div class="card-list">
    <ShadowBoxTitleDescription
      class="shadow-box"
      :title="cardListTitle"
      :titleCenter="titleCenter"
      opacity="_60">
      <div class="card-list-container">
        <!-- <PrevButton
          class="btn prev"
          @handlePrevBtnClick="handlePrevBtnClick"
        /> -->
        <div class="scroll-container">
          <template v-for="(cardItem, index) in cardList">
            <!-- <div class="card-container" :key="index">
              <img
                class="card"
                :src="cardItem.image" :alt="cardItem.card_name"
              >
              <div class="card-info">
                <div class="name">
                  <span class="text">{{cardItem.name}}</span>
                </div>
                <div class="model-number">
                  <span class="text">{{cardItem.model_number}}</span>
                </div>
                <div v-if="cardItem.num > 1" class="num">
                  <span class="text">{{cardItem.num}}{{t('枚セット')}}</span>
                </div>
                <div class="rarity">
                  <span class="text">{{cardItem.rarity_label}}</span>
                </div>
                <div v-if="isPoint" class="point_area"> -->
                  <!-- {{t('還元')}} -->
                  <!-- <img src="@/assets/point_mark.png" alt="ポイントマーク">
                  <span class="point">{{(cardItem.buy_point)}}</span> -->
                  <!--ここで枚数を掛けるとカードを引いた後が倍がけになるため掛けてはいけない-->
                <!-- </div>
              </div>
            </div> -->

            <div class="select-card" :key="index">
              <div class="image-area">
                <img
                  class="card"
                  @click.stop="handleCardSelect"
                  :src="cardItem.image"
                  :alt="cardItem.name"
                >
              </div>
              <div class="text_area">
                <div class="card-info" @click.stop="handleCardSelect">
                  <div class="name">
                    <span class="text">{{cardItem.name}}</span>
                  </div>
                  <span class="rarity">
                    <span class="text">{{cardItem.rarity_label}}</span>
                  </span>
                  <!-- <div class="model-number">
                    <span class="text">{{cardItem.model_number}}</span>
                  </div> -->
                  <span v-if="cardItem.num > 1" class="num">
                    <span class="text"><number>{{cardItem.num}}</number>{{t('枚セット')}}</span>
                  </span>
                </div>
                <div v-if="isPoint" class="point_area">
                  <img src="/img/icons/coin.png" alt="ポイントマーク">
                  <span class="point"><number>{{cardItem.buy_point}}</number></span>
                </div>
              </div>
            </div>

          </template>
          <div v-if="cardList.length == 0" class="no_card">
            <span>無し</span>
          </div>
        </div>
      </div>
    </ShadowBoxTitleDescription>
      <!-- <NextButton
        class="btn next"
        @handleNextBtnClick="handleNextBtnClick"
      /> -->
  </div>
</template>

<script>
import ShadowBoxTitleDescription from '@/components/molecules/ShadowBoxTitleDescription.vue';
import t from '@/plugins/i18n';

export default {
  name: 'CardList',
  mixins: [t],

  props: {
    cardListTitle: {
      type: String,
    },
    cardList: {
      type: Array,
      default: () => [],
    },
    isPoint: {
      type: Boolean,
      default: true,
    },
    titleCenter: {
      type: Boolean,
      default: false,
    },
  },

  components: {
    ShadowBoxTitleDescription,
    // PrevButton,
    // NextButton,
  },

  methods: {
    // handlePrevBtnClick() {
    //   this.$emit('handlePrevBtnClick');
    // },
    // handleNextBtnClick() {
    //   this.$emit('handleNextBtnClick');
    // },
  },
};
</script>

<style lang="scss" scoped>
$shadowBtnHeight: 77px;

.card-list{
  width: 100%;
  .card-list-container{
    position: relative;
    width: 100%;
    // min-height: 154px;
    white-space: nowrap;
    .btn{
      position: absolute;
      height: $shadowBtnHeight;
      top: calc(50% - #{$shadowBtnHeight}/2);
      &.prev{
        left: 10px;
      }
      &.next{
        right: 10px;
      }
      @media screen and  (min-width: $tabletWidth) {
        display: none;
      }
    }
    .scroll-container{
      display: flex;
      overflow: hidden;
      overflow-x: auto;
      padding-bottom: 5px;
      justify-content: space-around;
      flex-wrap: wrap;
      overflow: visible;
    //   @media screen and  (min-width: $tabletWidth) {
    //     display: flex;
    //     justify-content: center;
    //     flex-wrap: wrap;
    //     overflow: visible;
    //     margin-top: -10px;
    //     .card{
    //       margin-top: 10px;
    //     }
    //   }
    //   &::before{
    //     content: '';
    //     min-width: 20px;
    //     flex: 1;
    //     height: 10px;
    //   }
    //   &::after{
    //     content: '';
    //     min-width: 20px;
    //     flex: 1;
    //     height: 10px;
    //   }
    //   .card-container{
    //     display: flex;
    //     flex-direction: column;
    //     width: 130px;
    //     min-width: 130px;
    //     padding: 10px;
    //     box-shadow: 2px 2px 4px #e0e0e0;
    //     border-radius: 14px;
    //     & + .card-container{
    //       margin-left: 20px;
    //     }
    //     &:first-of-type{
    //       margin: 0 auto;
    //     }
    //     .card{
    //       width: 100%;
    //       height: 146px;
    //     }
    //     .card-info{
    //       display: flex;
    //       flex-direction: column;
    //       justify-content: space-between;
    //       flex: 1;
    //       width: 100%;
    //       .name, .model-number{
    //         display: flex;
    //         // justify-content: center;
    //         align-items: center;
    //         width: 100%;
    //         padding: 2px 0;
    //         .text{
    //           display: inline-block;
    //           font-family: $notoSans;
    //           font-size: 12px;
    //           color: #000;
    //           line-height: 1.25;
    //           white-space: pre-wrap;
    //         }
    //       }
    //       .model-number {
    //         text-align: center;
    //       }
    //       .num {
    //         .text {
    //           color: #000;
    //         }
    //       }
    //       .rarity {
    //         // padding: 0px 10px 4px 10px;
    //         // border-radius: 5px;
    //         // border: solid 1px $yellow;
    //         span {
    //           font-size: 11px;
    //           color: $white;
    //           background-color: #000;
    //           display: block;
    //           padding: 3px 8px;
    //           border-radius: 5px;
    //           white-space: initial;
    //         }
    //       }
    //       .point_area {
    //         font-size: 12px;
    //         color: #000;
    //         display: flex;
    //         justify-content: center;
    //         align-items: center;
    //         // flex-wrap: wrap;
    //         .point {
    //           font-size: 20px;
    //           font-weight: 700;
    //           margin-left: 5px;
    //           position: relative;
    //           // &:before {
    //           //   content: "P";
    //           //   font-size: 12px;
    //           //   width: 18px;
    //           //   height: 18px;
    //           //   border-radius: 100px;
    //           //   display:inline-flex;
    //           //   justify-content: center;
    //           //   align-items: center;
    //           //   background-color: $white;
    //           //   color: $deepGray;
    //           //   margin-right: 5px;
    //           //   position: relative;
    //           //   top: -2px;
    //           // }
    //         }
    //         img {
    //           width: 29px;
    //           box-shadow: 2px 2px 10px #e0e0e0;
    //           border-radius: 20px;
    //         }
    //       }
    //     }
    //   }
    }
  }
  .no_card {
    margin-top: 10px;
    margin-top: 10px;
    font-size: 24px;
    font-weight: bold;
  }
}

.select-card{
  display: flex;
  width: 40%;
  padding: 10px;
  box-shadow: 2px 2px 4px #e0e0e0;
  border-radius: 60px;
  position: relative;
  margin-top: 45px;
  &.active {
    // padding: 4px;
    border: solid 2px #4bcbe9;
  }
  .card{
    height: 150px
  }
  .image-area {
    position: absolute;
    // 上下中央に配置
    top: 53%;
    left: -15px;
    transform: translateY(-50%);
  }
  .chkblock {
    position: absolute;
    top: 7px;
    right: 7px;
    .check-box{
      width: 20px;
      height: 20px;
      margin: 0 auto 0;
      border-radius: 30px;
      border: none;
      background-color: #dadfe8;
      &.active{
        background-color: #4bcbe9;
      }
    }
  }
  .text_area {
    width: 60%;
    margin-left: auto;
    text-align: left;
  }
  .card-info{
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    flex: 1;
    width: 100%;
    margin-top: 5px;
    // 下にドット線を引く
    border-bottom: 1px dashed #bec2cd;
    .name{
      display: flex;
      // justify-content: center;
      align-items: center;
      width: 100%;
      padding: 2px 0;
      .text{
        display: inline-block;
        font-family: $notoSansJP;
        font-size: 12px;
        color: $black;
        line-height: 1.25;
        word-break: break-all;
        // white-space: pre-wrap;
        // margin-left: 5px;
        font-weight: bold;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
    .name {
      color: $black;
    }
    .model-number {
      font-size: 14px;
      color: #7f88a0;
    }
    .rarity {
      span {
        font-size: 14px;
        color: #7f88a0;
        // border: solid 1px $black;
        display: block;
        // border-radius: 5px;
        white-space: initial;
        // background-color: $black;
      }
    }
  }
  .point_area {
    font-size: 12px;
    color: $black;
    display: flex;
    align-items: center;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    .point {
      font-size: 16px;
      font-weight: 700;
      margin-left: 5px;
      position: relative;
    }
    img {
      width: 13px;
      box-shadow: 2px 2px 10px #e0e0e0;
      border-radius: 20px;
    }
  }
}
@media screen and  (max-width: $tabletWidth) {
  .select-card {
    .text_area {
      width: 50%;
    }
    .card{
      height: 120px
    }
    .point_area {
      margin-left: 0;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .card-info{
      .name{
        .text{
          font-size: 10px;
        }
      }
      .model-number {
        font-size: 12px;
      }
      .rarity {
        span {
          font-size: 12px;
        }
      }
    }
  }
}
</style>
